import React, { useMemo, useState } from 'react'

import { Container, Modal, ModalBody, ModalFooter, ModalHeader, Row, Col, FormGroup, Label, Input, Button, CustomInput } from "reactstrap"
import Cargando from '../Cargando';
import IconCloseModal from './IconCloseModal';
import SaveSVG from "./../../../assets/icons/HorasExtras/Guardar.svg"
import { ResponseRequestGeneric } from 'components/Types/GeneralTypes';

export type PropsModalConfirmacion = {
    show: boolean,
    size: "xl" | "sm" | "md" | "lg",
    asyncAccion: boolean,
    asyncClose: boolean,
    onClose: () => void,
    asyncAfterOnClose?: () => Promise<void>,
    onClick?: () => void,
    asyncOnClick?: () => Promise<number>;
    mensajeConfirmacion: string,
    mensajeEncabezado?:string,
    classNamemensajeConfirmacion?: string,
    classNameContentModal?: string,
    classNameAllModal?: string
    nombreBotonAccion: string,
    nombreBotonCerrarModal?: string,
    nombreBotonAfterOnClose?: string,
    closeAfterAccion: boolean
    hideBotonCerrar: boolean,
    contentModal?: HTMLElement | React.ReactElement
    tituloModal?: string,
    botonesAccionParteSuperior?: boolean,
    centered?: boolean,
    classNameBotonCerrarModal?: React.CSSProperties,
    classNameContainer?: string
    colorButtonAccion?: string
    iconModal?: string
}

type StateModalConfirmacion = {
    realizandoAccion: boolean,
    accionTerminada: boolean,
    errorAsyncAccion: boolean
}

export default function ModalConfirmacionNew(props: PropsModalConfirmacion) {

    const initialState: StateModalConfirmacion = {
        realizandoAccion: false,
        accionTerminada: false,
        errorAsyncAccion: false,
    }

    const [stateModal, setstateModal] = useState<StateModalConfirmacion>(initialState);

    function CerrarModal() {
        setstateModal(initialState);
        props.onClose();
        document.body.classList.remove('modal-open')
    }

    async function CerrarModalAndAfterClose(callbackClose: () => Promise<void>) {
        setstateModal(initialState);
        await callbackClose();

    }

    async function AccionAsync(callbackAccion: () => Promise<number>) {
        const { asyncAfterOnClose } = props;
        setstateModal({ ...stateModal, realizandoAccion: true })
        var statusAccion = await callbackAccion();

        if (props.closeAfterAccion && typeof (asyncAfterOnClose) === "function") {
            await CerrarModalAndAfterClose(asyncAfterOnClose);
        }
        else if (props.closeAfterAccion && typeof (asyncAfterOnClose) === "undefined") {
            CerrarModal();
        }

        else {
            if (statusAccion > -1) {
                setstateModal({ ...stateModal, realizandoAccion: false, accionTerminada: true })
            }
            else {
                setstateModal({ ...stateModal, realizandoAccion: false, accionTerminada: true, errorAsyncAccion: true })
            }
        }

    }

    function AccionNotAsync(callbackAccion: () => void) {

        const { closeAfterAccion } = props;
        callbackAccion();

        if (closeAfterAccion) {
            CerrarModal();
        }
    }

    const BotonCerrar = useMemo(() => {
        return (
            <IconCloseModal handleClickIcon={() => CerrarModal()} />
        )
    }, [props])


    const BotonCancelar = useMemo(() => {
        return (
            <Button className="btn-cancelar" color="secondary" disabled={stateModal.realizandoAccion} onClick={() => CerrarModal()}> {props.nombreBotonCerrarModal !== undefined ? props.nombreBotonCerrarModal : "Cerrar Mensaje"} </Button>
        )
    }, [stateModal, props])

    const BotonAccion = useMemo(() => {
        const { asyncOnClick, onClick } = props;

        const colorButton = props.colorButtonAccion ? props.colorButtonAccion : "secondary"

        if (props.asyncAccion && asyncOnClick) {
            return (
                <Button className="btn-aceptar mr-2" color={colorButton} onClick={async () => await AccionAsync(asyncOnClick)}>{props.nombreBotonAccion}</Button>
            )
        }
        else if (!props.asyncAccion && onClick) {
            return (
                <Button className="btn-aceptar mr-2" color={colorButton} onClick={() => AccionNotAsync(onClick)}>{props.nombreBotonAccion}</Button>
            )
        }
        else {
            return (<div></div>)
        }


    }, [props, stateModal])

    const BotonCerrarYAccion = useMemo(() => {
        const { asyncAfterOnClose, nombreBotonAfterOnClose } = props

        if (asyncAfterOnClose && nombreBotonAfterOnClose) {
            return (
                <Button color="primary" id="botonAfterOnClose" className="mr-2" onClick={async () => await CerrarModalAndAfterClose(asyncAfterOnClose)}>{nombreBotonAfterOnClose ?? "Cerrar y Continuar"}</Button>
            )
        }
    }, [props, stateModal])

    const ContenidoModal = useMemo(() => {
        const { accionTerminada, realizandoAccion, errorAsyncAccion } = stateModal;
        const { asyncClose } = props;



        const botonesAcciones = (
            <>
                {!realizandoAccion && accionTerminada && asyncClose && !errorAsyncAccion && BotonCerrarYAccion}
                {!props.hideBotonCerrar && !realizandoAccion && BotonCancelar}
                {!realizandoAccion && !accionTerminada && BotonAccion}

            </>
        )




        var parteinicial = (
            <>
                {
                    !realizandoAccion && !accionTerminada && props.mensajeConfirmacion &&
                    <Row className="justify-content-center">
                        <p className={`text-center ${props.classNamemensajeConfirmacion}`}>{props.mensajeConfirmacion}</p>
                    </Row>
                }
            </>




        )

        if (props.botonesAccionParteSuperior !== undefined && props.botonesAccionParteSuperior === true) {
            parteinicial = (
                <>
                    {
                        props.iconModal &&
                        <Row className="justify-content-center">
                            {
                                <img src={props.iconModal} width={50} height={50}></img>
                            }
                        </Row>

                    }
                    {
                        props.mensajeEncabezado &&
                        <Container fluid ={true}>
                            <Row className="justify-content-center">
                                <Col className="text-center">
                                    {props.mensajeEncabezado}
                                </Col>
                            </Row>
                        </Container>
                    }

                    <Row className="justify-content-center">
                        {
                            !realizandoAccion && !accionTerminada &&
                            <Col xl={8} lg={8} md={12}>
                                <p className={`text-center ${props.classNamemensajeConfirmacion}`}>{props.mensajeConfirmacion}</p>
                            </Col>
                        }
                    </Row>
                </>

            );
        }

        var botones = (
            <>
                <Row className="justify-content-center">
                    {!realizandoAccion && accionTerminada && asyncClose && !errorAsyncAccion && <Col xl={1} lg={1} md={6}>{BotonCerrarYAccion}</Col>}
                    {!props.hideBotonCerrar && !realizandoAccion && <Col xl={2} lg={1} md={6} className="d-flex ">{BotonCancelar}</Col>}
                    {!realizandoAccion && !accionTerminada && <Col xl={2} lg={1} md={6} className="d-flex ">{BotonAccion}</Col>}
                </Row>

            </>
        )

        return (
            <Container className={props.classNameContainer ?? ""}>

                {
                    parteinicial
                }
                {
                    props.contentModal
                }

                {botones}


                <Row className="justify-content-center" style={props.classNameBotonCerrarModal}>
                    {
                        (props.botonesAccionParteSuperior === undefined || (props.botonesAccionParteSuperior !== undefined && props.botonesAccionParteSuperior === false))
                        && botonesAcciones
                    }



                </Row>
                <Row>
                    <Col>
                        {
                            realizandoAccion && !accionTerminada &&
                            <Row className="justify-content-center">
                                <Cargando />
                            </Row>
                        }
                    </Col>

                </Row>
                <Row className="justify-content-center">
                    <Col>
                        {
                            !realizandoAccion && accionTerminada && !errorAsyncAccion &&
                            <p className='error-small'>Se ha completado la acción</p>
                        }
                        {
                            !realizandoAccion && accionTerminada && errorAsyncAccion &&
                            <p className='error-small'>Ha ocurrido un inconveniente al tratar de realizar la acción</p>
                        }
                    </Col>
                </Row>
            </Container>
        )
    }, [props, stateModal])

    return (
        <Modal
            isOpen={props.show}
            scrollable={true}
            size={props.size}
            fullscreen={props.size}
            centered={props.centered !== undefined ? props.centered : false}
            onClosed={() => CerrarModal()}
            contentClassName={(props.classNameAllModal ?? "custom-modal-style") === "default" ? "" : props.classNameAllModal}
        >
            <ModalHeader close={BotonCerrar}>
                <div className='tituloModalDocumentos'>{props.tituloModal ? props.tituloModal : "Mensaje de confirmación"}</div>
            </ModalHeader>
            <ModalBody className={props.classNameContentModal ?? ""}>
                {ContenidoModal}
            </ModalBody>

        </Modal>
    )
}
